import { NgModule } from '@angular/core';
import { ButtonComponent } from './button/button.component';
import { BadgeComponent } from './badge/badge.component';
import { RoleBadgeComponent } from './badge/role-badge.component';
import { DatatableModule } from './datatable/datatable.module';
import { CalendarModule } from './calendar/calendar.module';
import { DateRangeFilterComponent } from './date-range-filter/date-range-filter.component';

const MODULES = [
  ButtonComponent,
  BadgeComponent,
  RoleBadgeComponent,
  DatatableModule,
  CalendarModule,
  DateRangeFilterComponent
];

@NgModule({
  declarations: [],
  imports: [...MODULES],
  exports: [...MODULES]
})
export class UiModule {}
